import paginationMixin from '~/mixins/pagination';
import Report from '~/components/flytipping/Report.vue';

export default {
    components: {
        Report,
    },
    mixins: [paginationMixin],
    computed: {
        showStats() {
            if (!this.$store.state.isMobile) {
                return true;
            }
            return !this.$route.query.page || this.$route.query.page === 1;
        },
    },
};
